import React, { useState, useRef, useEffect } from 'react';
import styles from './CreateStudents.module.scss';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import userIcon from '../../../../assets/Imagess/userinputicon.svg';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import {
  API_URL,
  quillFormats,
  quillModules,
  securityHeaders,
} from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import { toast } from 'react-toastify';
import 'react-quill/dist/quill.snow.css';
import { isEmpty } from 'lodash';
import { useFetchStoryById } from '../../../../Hooks/Alumni';
import TextInput from '../../../Atoms/Inputs/TextInput';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import Loader from '../../../Molecules/Loader/Loader';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';

import he from 'he';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';
import UploadImage from '../../../Atoms/upload-image/UploadImage';
import { useFetchDegrees } from '../../../../Hooks/Programs';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import TextEditor from '../../../Molecules/Email/TextEditor';

const UpdateStory = ({ type }) => {
  const { data: degrees } = useFetchDegrees(100, 1);
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const customizedToast = useToast();
  const formikRef = useRef(null);
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState('');
  const { data: story, isLoading, refetch } = useFetchStoryById(id);
  useEffect(() => {
    if (!isEmpty(id) && undefined !== id) {
      refetch();
    }
  }, [id]);
  useEffect(() => {
    if (!isEmpty(story)) {
      const storyData = story.data[0];
      formikRef.current.setValues({
        nameAr: storyData.alumniName_AR || '',
        achievementsAr: he.decode(storyData.achievements_AR || ''),
        Speech_AR: he.decode(storyData.speech_AR || ''),
        programId: storyData.programId || '',
      });
      setImageSrc(
        sanitizeAndValidateUrl(
          `${story?.data[0]?.url}${story?.data[0]?.alumniImage}`
        )
      );
    }
  }, [story]);

  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required('Arabic event name is required'),
    achievementsAr: Yup.string().required('مطلوب تعبئته'),
    Speech_AR: Yup.string().required('مطلوب تعبئته'),
    programId: Yup.string().required('Program is required'),
    image:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Image is required'),
  });

  const createStory = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Alumni/AlumniSuccessStories`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: (data) => {
      customizedToast.open(
        id ? 'تم تحديث القصة بنجاح!' : 'تم إنشاء القصة بنجاح!'
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('AlumniName_AR', values.nameAr);
    formData.append('Achievements_AR', values.achievementsAr);
    const storyId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('Speech_AR', values.Speech_AR);
    formData.append('AlumniSuccessStoryId', storyId);
    formData.append('ProgramId', values.programId);
    if (undefined !== values.image) {
      formData.append('AlumniImage', values.image);
    }
    createStory.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={id ? 'تحديث القصة' : 'إنشاء قصة'}
        />
      </div>
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: story?.data[0]?.alumniName_AR || '',
            achievementsAr: he.decode(story?.data[0]?.achievements_AR || ''),
            Speech_AR: he.decode(story?.data[0]?.Speech_AR || ''),
            image: null,
            programId: story?.data[0]?.programId || '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form className={styles.form}>
              {console.log('vnjkfdnv', values)}
              <div className={styles['steps']}>
                <div
                  className={`${styles['step-container']} ${styles['rtl']}`}
                  style={{ display: 'block' }}
                >
                  <TextInput
                    label="الاسم"
                    placeholder="أدخل الاسم"
                    icon={userIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                      marginBottom: '26px',
                    }}
                    containerStyle={{ padding: '0px' }}
                    name="nameAr"
                    value={values.nameAr}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                </div>{' '}
                <CustomSelect
                  label="البرنامج"
                  placeholder="اختيار البرنامج"
                  style={{ width: '100%' }}
                  iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                  dropdownStyle={{ marginTop: '4px' }}
                  value={values.programId}
                  touched={touched.programId}
                  errors={errors.programId}
                  onChange={(e) => setFieldValue('programId', e.value)}
                  options={degrees?.data?.items?.map((option) => ({
                    value: option.degreeId,
                    text: option.degreeNameAr,
                  }))}
                  right
                />{' '}
              </div>
              <div>
                <div
                  className={`${styles['quill-container']} ${styles['rtl']}`}
                >
                  <TextEditor
                    label="إنجازات الخريجين"
                    value={values.achievementsAr}
                    onChange={(name, value) => setFieldValue(name, value)}
                    modules={quillModules}
                    formats={quillFormats}
                    placeholder="Write something..."
                    name="achievementsAr"
                    errors={errors.achievementsAr}
                    touched={touched.achievementsAr}
                    right
                  />
                </div>
              </div>{' '}
              <div className={`${styles['quill-container']} ${styles['rtl']}`}>
                <TextEditor
                  label={type === 'speech' ? 'ادخل الخطاب ' : 'محتوى الشهادة'}
                  value={values.Speech_AR}
                  onChange={(name, value) => setFieldValue(name, value)}
                  modules={quillModules}
                  formats={quillFormats}
                  name="Speech_AR"
                  placeholder={
                    type === 'speech' ? 'أدخل الخطاب' : 'أدخل الشهادة'
                  }
                  errors={errors.Speech_AR}
                  touched={touched.Speech_AR}
                  right
                />
              </div>
              {errors.image && (
                <div className={styles['error-message']}>
                  <p>{errors.image}</p>
                </div>
              )}
              <UploadImage
                onCropImage={(croppedImageFile) =>
                  setFieldValue('image', croppedImageFile)
                }
                value={imageSrc}
                setFieldValue={(field, value) => console.log(field, value)}
              />{' '}
              <button
                type="submit"
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateStory;
